import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import format from 'date-fns/format';
import { Observable, Subscription } from 'rxjs';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { ContratosApi } from 'src/app/shared/api/contratos.api';
import { TipoFuncionalidade, TipoValidacaoCadastral, ValidacaoCadastroModalComponent, ValidacaoCadastroModalData } from 'src/app/shared/components/validacao-cadastro-modal/validacao-cadastro-modal.component';
import { StatusParcelaEnum } from 'src/app/shared/enums/status-parcela.enum';
import { TipoPlano } from 'src/app/shared/enums/tipo-plano.enum';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { MensagensService } from 'src/app/shared/mensagens/mensagens.service';
import { Contrato } from 'src/app/shared/models/contrato.model';
import CustomizacaoParcelamento from 'src/app/shared/models/customizacao-parcelamento.model';
import { FuncionalidadeEnum } from 'src/app/shared/models/funcionalidade-enum';
import { MapaPlanosPorOrigem } from 'src/app/shared/models/mapa-planos-por-origem.model';
import { NovoPlanoRenegociacao } from 'src/app/shared/models/novo-plano-renegociacao.model';
import { PlanoEfetivado } from 'src/app/shared/models/plano-efetivado.model';
import PlanoRenegociacaoMassiva from 'src/app/shared/models/plano-renegociacao-massiva.model';
import { ValidacaoCadastro } from 'src/app/shared/models/validacao-cadastro.model';
import { BaseModalService } from 'src/app/shared/services/base-modal.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import DateUtils from 'src/app/shared/utils/date-utils';
import { ConfirmaRenegociacaoModalComponent } from '../confirma-renegociacao-modal/confirma-renegociacao-modal.component';
import { ContratoService } from '../contrato.service';
import { ModalWrapperData } from './../../shared/models/modal-wrapper-data.model';
import { TipoPlanoEnum } from './../../shared/models/novo-plano-renegociacao.model';
import { SegundaViaPlanoEfetivadoCheckoutType } from './plano-efetivado-card/plano-efetivado-card.component';

@Component({
  selector: 'app-renegocicao-page',
  templateUrl: './renegocicao-page.component.html',
  styleUrls: ['./renegocicao-page.component.scss'],
})
export class RenegocicaoPageComponent implements OnInit, OnDestroy {

  subscriptions = new Subscription();
  idContrato: string;
  planosRenegociacaoMassiva: PlanoRenegociacaoMassiva[] = [];
  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset);
  TipoPlano = TipoPlano;
  consultaPlanosCyberExecutada = false;
  loginComColaborador = this.autenticacaoService.colaboradorAutenticado;

  contrato: Contrato;
  novosPlanos: NovoPlanoRenegociacao[] = [];
  planoEfetivado: PlanoEfetivado;
  planosPorOrigem: MapaPlanosPorOrigem;
  validacaoCadastro: ValidacaoCadastro;
  modalValidacaoRef: MatDialogRef<any>;
  permitirPagamentoPix: boolean = false;

  constructor(
    private contratosApi: ContratosApi,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private mensagems: MensagensService,
    private contratoService: ContratoService,
    private breakpointObserver: BreakpointObserver,
    private autenticacaoService: AutenticacaoService,
    private dialog: MatDialog,
    private googleAnalyticsService: GoogleAnalyticsService,
    private baseModalService: BaseModalService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(this.route.params.subscribe(({ idContrato }) => {
      this.idContrato = idContrato;
      this.verificarPermissaoPagamentoPix(idContrato);
      this.buscarContrato(idContrato);
      this.buscarPlanoEfetivado(idContrato);
      this.buscarPlanos(idContrato);
    }));

    this.validarCadastro();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.modalValidacaoRef) {
      this.modalValidacaoRef.close({ closeFromRedirect: true });
    }
  }

  get possuiAlgumContrato(): boolean {
    if (this.planosPorOrigem) {
      const planosArray = Object.keys(this.planosPorOrigem).reduce((prev, key) => [...prev, ...this.planosPorOrigem[key].PARCELADO, ...this.planosPorOrigem[key].QUITACAO], []);
      return planosArray.length > 0;
    }
    return this.planosRenegociacaoMassiva.length > 0;
  }

  get planosEspeciais() {
    return [...this.planosPorOrigem.ESPECIAL.PARCELADO, ...this.planosPorOrigem.ESPECIAL.QUITACAO]
      .sort((a) => a.tipo === TipoPlanoEnum.PARCELADO ? 1 : -1);
  }

  get planosCyberParcelado() {
    return this.planosPorOrigem.CYBER.PARCELADO;
  }

  get planosCyberQuitacao() {
    return this.planosPorOrigem.CYBER.QUITACAO;
  }

  private async buscarContrato(idContrato: string): Promise<void> {
    try {
      this.loader.start();
      this.contrato = await this.contratoService.getContrato(idContrato);
      this.enviarEventoGTM();
    } catch (response) {
      if (response && response.error) {
        this.mensagems.erro(response.error.mensagem);
      } else {
        this.mensagems.erro('Erro ao buscar o contrato. Por favor tente novamente mais tarde.');
      }
    } finally {
      this.loader.stop();
    }
  }

  async selecionarPlano(plano: NovoPlanoRenegociacao): Promise<any> {
    this.router.navigate([`/portal/contratos/${this.idContrato}/renegociacao/${plano.id}/resumo`]);
  }

  voltarParaContratos({ selectedIndex }: StepperSelectionEvent): void {
    if (selectedIndex === 0) {
      this.router.navigate(['/portal/contratos']);
      return;
    }
  }

  async recalcularPlano(customizacaoParcelamento: CustomizacaoParcelamento): Promise<void> {
    try {
      this.loader.start();
      this.planosPorOrigem = await this.contratoService.recalcularPlanos(this.idContrato, customizacaoParcelamento);
    } catch (response) {
      if (response && response.error) {
        this.mensagems.erro(response.error.mensagem);
      } else {
        this.mensagems.erro('Erro ao recalcular os planos. Por favor tente novamente mais tarde.');
      }
    } finally {
      this.loader.stop();
    }
  }

  desistirDoPlanoEfetivado(): void {
    this.dialog.open(ConfirmaRenegociacaoModalComponent).afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.planoEfetivado = null;
      }
    });

    return;
  }

  async buscarPlanoEfetivado(contratoId: string): Promise<void> {
    this.planoEfetivado = await this.contratoService.buscarPlanoEfetivado(contratoId);
  }

  async irParaSegundaViaPlanoEfetivado(checkoutType: SegundaViaPlanoEfetivadoCheckoutType) {
    const canProceed = await this.validarCadastro();
    const route = checkoutType === SegundaViaPlanoEfetivadoCheckoutType.PIX ? 'checkout/pix' : 'checkout/boleto';
    if (canProceed) {
      this.router.navigate([`portal/contratos/${this.idContrato}/renegociacao/acordo-vigente/${route}`]);
    }
  }

  enviarEventoGTM() {
    this.googleAnalyticsService.pushEvent({
      event: 'update',
      pagina: {
        nomePagina: '/renegociacao/contratos/renegociacao',
        templatePagina: 'renegociacao',
        contratos: {
          numeroContrato: this.contrato.contrato,
          dataVencimento: format(DateUtils.normalizedDate(this.contrato.vencimento), 'dd/MM/yyyy'),
          saldo: this.contrato.saldo,
          parcelasPagas: this.contrato.parcelas.reduce((acc, parcela) => parcela.statusParcela === StatusParcelaEnum.STATUS_PAGO ? acc += 1 : acc, 0),
          situacao: this.googleAnalyticsService.situacaoContratoPipe(this.contrato.situacao),
          mercadoria: this.contrato?.mercadoria?.mercadorias.join(' / '),
        }
      }
    });
  }

  async buscarPlanos(idContrato: string) {
    try {
      this.loader.start();
      this.planosPorOrigem = await this.contratoService.buscarNovosPlanos(idContrato);
    } catch (response) {
      if (response && response.error) {
        this.mensagems.erro(response.error.mensagem);
      } else {
        this.mensagems.erro('Erro ao buscar os planos. Por favor tente novamente mais tarde.');
      }
    } finally {
      this.consultaPlanosCyberExecutada = true;
      this.loader.stop();
    }
  }

  async validarCadastro() {
    try {
      this.validacaoCadastro = await this.contratoService.validarCadastro(FuncionalidadeEnum.RENEGOCIACAO);

      if (this.validacaoCadastro.validarCadastro) {
        const data: ModalWrapperData<ValidacaoCadastroModalData> = {
          title: 'Verificação de segurança',
          component: ValidacaoCadastroModalComponent,
          config: { disableClose: true, autoFocus: false },
          data: {
            funcionalidade: TipoFuncionalidade.VALIDACAO,
            tipo: TipoValidacaoCadastral.PHONE,
            initialValue: this.validacaoCadastro.telefoneCadastrado,
          }
        };

        this.modalValidacaoRef = this.baseModalService.showModal(data);

        const modalResponse: { valido: boolean, showConfirmationModal?: boolean } = await this.modalValidacaoRef.afterClosed().toPromise();

        if (modalResponse?.showConfirmationModal) {
          const confirm = await this.baseModalService.showConfirmationModal({
            text: 'Não conseguimos validar o número do celular informado. <strong>Atualize o número do celular no seu perfil.</strong>',
            confirmBtnText: 'Ir para o meu perfil',
            deniedBtnText: 'Agora não',
          }).afterClosed().toPromise();

          if (confirm) {
            this.router.navigate([`/portal/perfil`]);
          }
        }

        return modalResponse?.valido;
      }
      return true;
    } catch (response) {
      if (response && response.error) {
        this.mensagems.erro(response.error.mensagem);
      } else {
        this.mensagems.erro('Erro inesperado. Por favor tente novamente mais tarde.');
      }
    } finally {
      this.loader.stop();
    }
  }

  async verificarPermissaoPagamentoPix(contratoId: string) {
    try {
      this.loader.start();
      const res = await this.contratoService.verificarElegibilidadePagamentoCeler(contratoId);
      this.permitirPagamentoPix = res.elegivel;
    } catch (error) {
      this.permitirPagamentoPix = false;
    } finally {
      this.loader.stop();
    }
  }

}
